import { APP_MANAGED_ROUTES } from 'common/constants';
import { useProductSegmentation } from './use-product-segmentation.hook';

interface PaymentLinkVisibility {
  showMedicarePremium: boolean;
  showSupplementalAutoPay: boolean;
  showPDPPremium: boolean;
  showManagePharmacySettings: boolean;
  isAuthorized: (route: string) => boolean;
}

const PAYMENT_ROUTES_VISIBILITY: Record<
  string,
  'showMedicarePremium' | 'showSupplementalAutoPay' | 'showPDPPremium'
> = {
  [APP_MANAGED_ROUTES.PDP_PREMIUM_PAYMENT]: 'showPDPPremium',
  [APP_MANAGED_ROUTES.SUPPLEMENTAL_PREMIUM_PAYMENT]: 'showSupplementalAutoPay',
  [APP_MANAGED_ROUTES.MEDICARE_PREMIUM_PAYMENT]: 'showMedicarePremium',
};

export function usePaymentLinkVisibility(): PaymentLinkVisibility {
  const {
    showMedicarePremium,
    showPDPPremium,
    showSupplementalAutoPay,
    showPharmacySettings,
  } = useProductSegmentation();

  // Use the pharmacy settings flag from product segmentation
  const showManagePharmacySettings = showPharmacySettings;

  const isAuthorized = (route: string): boolean => {
    const visibilityKey = PAYMENT_ROUTES_VISIBILITY[route];
    if (!visibilityKey) {
      return true;
    }
    return (
      {
        showMedicarePremium,
        showSupplementalAutoPay,
        showPDPPremium,
      }[visibilityKey] ?? false
    );
  };

  return {
    showMedicarePremium,
    showSupplementalAutoPay,
    showPDPPremium,
    showManagePharmacySettings,
    isAuthorized,
  };
}
